import { render, staticRenderFns } from "./PanoSection.vue?vue&type=template&id=0fa83847&scoped=true"
import script from "./PanoSection.vue?vue&type=script&lang=ts"
export * from "./PanoSection.vue?vue&type=script&lang=ts"
import style0 from "./PanoSection.vue?vue&type=style&index=0&id=0fa83847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa83847",
  null
  
)

export default component.exports